// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TherapySessionPage from './TherapySessionPage';
import HomePage from './HomePage';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import Footer from './Footer';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import CookiePolicyPage from './CookiePolicyPage';
import TermsAndConditionsPage from './TermsAndConditionsPage';
import DisclaimerPage from './DisclaimerPage';
import AcceptableUsePolicyPage from './AcceptableUsePolicyPage';
import { mouseflow } from 'react-mouseflow';
import NavigationBar from './Navbar';
import FrameworkPage from './FrameworkPage';
import AnaxDashboard from './pages/clients/anax/Dashboard';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// New component to handle conditional rendering of navigation and footer
const PageWrapper = ({ children }) => {
  const location = useLocation();
  const isAnaxRoute = location.pathname.startsWith('/clients/anax');

  return (
    <>
      {!isAnaxRoute && <NavigationBar />}
      {children}
      {!isAnaxRoute && <Footer />}
    </>
  );
};

function App() {
  const [therapySessionType, setTherapySessionType] = useState('voice');
  const [userState, setUserState] = useState({
    messages: [],
    voiceName: 'onyx',
  });

  const { data } = useVisitorData(
    { extendedResult: true },
    { immediate: true }
  );

  useEffect(() => {
    if (data?.visitorId) {
      setUserState((prevState) => ({
        ...prevState,
        visitorId: data.visitorId,
      }));
    }
  }, [data]);

  useEffect(() => {
    if (process.env.REACT_APP_NODE_ENV === 'production') {
      mouseflow.initialize('938e4828-fed5-4d28-843a-3cfb21b2cff4');
    }
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageWrapper>
        <Routes>
          <Route path="/" element={<HomePage userState={userState} setUserState={setUserState} />} />
          <Route
            path="/therapy-session"
            element={
              <TherapySessionPage
                therapySessionType={therapySessionType}
                setTherapySessionType={setTherapySessionType}
                userState={userState}
                setUserState={setUserState}
              />
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/acceptable-use-policy" element={<AcceptableUsePolicyPage />} />
          <Route path="/framework" element={<FrameworkPage />} />
          <Route path="/clients/anax/*" element={<AnaxDashboard />} />
        </Routes>
      </PageWrapper>
    </BrowserRouter>
  );
}

export default App;